import "@angular/localize/init";
import "classlist.js";
import "web-animations-js";
import "core-js/es/reflect";
import "zone.js";

(window as any).global = window;
